module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921044151_T.ca838714.jpg";